import { useRevolvingIndex } from '../../../../hooks/useRevolvingIndex';
import { KeyboardEventHandler } from 'react';

export function useAutoCompleteKeyboardSupport<T>(
  items: T[],
  onSelect?: (item: T) => void,
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>
): [number, KeyboardEventHandler<HTMLDivElement>] {
  const {
    nextIndex,
    previousIndex,
    index: selectedIndex,
    setIndex,
  } = useRevolvingIndex(items.length - 1);

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = e => {
    let wasHandled = false;

    switch (e.key) {
      case 'ArrowUp':
        previousIndex();
        wasHandled = true;
        break;
      case 'ArrowDown':
        nextIndex();
        wasHandled = true;
        break;
      case 'Home':
        setIndex(0);
        wasHandled = true;
        break;
      case 'End':
        setIndex(items.length - 1);
        wasHandled = true;
        break;
      case 'Enter':
        if (e.nativeEvent.isComposing) {
          break;
        }
      // eslint-disable-next-line no-fallthrough
      case 'Tab':
        if (items.length === 0) {
          return;
        }
        onSelect && onSelect(items[selectedIndex]);
        wasHandled = true;
        break;
      default:
        onKeyDown && onKeyDown(e);
    }

    if (wasHandled) {
      // Prevent any unintended page scrolling
      e.stopPropagation();
      e.preventDefault();
      return true;
    }

    return false;
  };

  return [selectedIndex, handleKeyDown];
}
